import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import ReasonItem from '../ReasonItem/ReasonItem'

import { REASONS, REASONS_TEXT, REASON_QUESTION } from './constants'
import styles from './Reasons.scss'

const Reasons = ({ onChange = () => {} }) => {
    const numberOfReasons = Object.keys(REASONS).length - 1
    const [checked, setChecked] = useState([])
    const [orders] = useState(
        Array(numberOfReasons)
            .fill(null)
            .map(() => Math.random() * numberOfReasons)
            .concat(numberOfReasons + 1)
    )

    useEffect(() => {
        onChange(checked)
    }, [checked])

    const generateReasons = () =>
        Object.keys(REASONS)
            .map((reason, index) => ({ order: orders[index], value: REASONS[reason], text: REASONS_TEXT[reason] }))
            .sort((a, b) => a.order - b.order)

    return (
        <div className={styles.base}>
            <p className={styles.question}>{REASON_QUESTION}</p>
            {generateReasons().map(reason => {
                function changeReasonCheck() {
                    const value = reason.value
                    if (checked.includes(value)) {
                        setChecked(checked.filter(reason => reason !== value))
                    } else {
                        setChecked(checked.concat(value))
                    }
                }

                return (
                    <ReasonItem
                        key={reason.value}
                        isChecked={checked.includes(reason.value)}
                        reason={reason.text}
                        onChange={changeReasonCheck}
                    />
                )
            })}
        </div>
    )
}

Reasons.propTypes = {
    onChange: PropTypes.func,
}

export default Reasons



// WEBPACK FOOTER //
// ./containers/ClanLeaving/components/Reasons/Reasons.jsx